import React from 'react'

export function ImandraXLogo(props: React.SVGProps<SVGSVGElement>) {
  const uid = React.useId().replace(/:/g, '')
  const gid = (n: number) => `paint${n}_${uid}`
  return (
    <svg
      {...props}
      viewBox="0 0 402 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M81.627 82.3648L54.658 55.2625L-0.000122398 109.894L54.658 76.3895L81.627 82.3648Z"
        fill={`url(#${gid(0)})`}
      />
      <path
        d="M27.1152 27.7334L54.6175 55.2892L109.276 0.617721L54.6175 34.9891L27.1152 27.7334Z"
        fill={`url(#${gid(1)})`}
      />
      <path
        d="M384.506 54.8557L395.777 70.4624H393.436L383.292 56.3296L373.148 70.4624H370.85L382.035 54.899L371.717 40.116H374.015L378.133 46.0552L383.335 53.4251L388.494 46.0552L392.613 40.116H394.91L384.506 54.8557Z"
        fill="currentColor"
      />
      <path
        d="M390.241 54.8557L401.513 70.4624H399.172L389.027 56.3296L378.883 70.4624H376.585L387.77 54.899L377.452 40.116H379.75L383.868 46.0552L389.071 53.4251L394.23 46.0552L398.348 40.116H400.646L390.241 54.8557Z"
        fill="currentColor"
      />
      <path
        d="M117.957 40.116H125.022V70.271H117.957V40.116Z"
        fill="currentColor"
      />
      <path
        d="M164.016 40.116H170.348V70.271H163.326V51.4026L154.452 62.2584H153.074L144.113 51.3595V70.271H137.092V40.116H143.424L153.72 52.9534L164.016 40.116Z"
        fill="currentColor"
      />
      <path
        d="M205.087 70.271L202.847 64.8431H187.985L185.745 70.271H178.206L191.733 40.116H199.272L212.712 70.271H205.087ZM195.481 46.8794L190.527 58.769H200.349L195.481 46.8794Z"
        fill="currentColor"
      />
      <path
        d="M241.535 40.116H248.556V70.271H242.224L228.568 51.618L228.654 59.7598V70.271H221.632V40.116H227.965L241.621 58.8552L241.535 50.7995V40.116Z"
        fill="currentColor"
      />
      <path
        d="M272.376 40.116C275.478 40.116 278.192 40.7335 280.518 41.9684C282.873 43.2033 284.682 44.9695 285.946 47.2671C287.238 49.5359 287.885 52.178 287.885 55.1935C287.885 58.209 287.238 60.8655 285.946 63.163C284.682 65.4318 282.873 67.1837 280.518 68.4186C278.192 69.6535 275.478 70.271 272.376 70.271H260.013V40.116H272.376ZM272.376 64.1108C274.904 64.1108 276.943 63.3066 278.494 61.6984C280.044 60.0901 280.82 57.9218 280.82 55.1935C280.82 53.3842 280.461 51.819 279.743 50.4979C279.054 49.1482 278.063 48.1143 276.77 47.3963C275.507 46.6496 274.042 46.2763 272.376 46.2763H267.078V64.1108H272.376Z"
        fill="currentColor"
      />
      <path
        d="M304.089 60.3198H308.182L315.849 70.271H324.25L315.72 59.7167C317.903 59.0275 319.583 57.8644 320.76 56.2274C321.967 54.5904 322.57 52.6232 322.57 50.3256C322.57 48.3153 322.125 46.5347 321.234 44.9839C320.344 43.4331 319.08 42.2412 317.443 41.4084C315.806 40.5468 313.897 40.116 311.714 40.116H297.024V46.147H310.895C312.389 46.147 313.538 46.5204 314.342 47.2671C315.175 48.0138 315.591 49.062 315.591 50.4118C315.591 51.7616 315.189 52.8098 314.385 53.5565C313.581 54.2745 312.418 54.6335 310.895 54.6335H304.045L304.046 51.2918L297.024 48.8898V70.271H304.089V60.3198Z"
        fill="currentColor"
      />
      <path
        d="M356.966 70.271L354.726 64.8431H339.863L337.623 70.271H330.085L343.611 40.116H351.15L364.59 70.271H356.966ZM347.359 46.8794L342.405 58.769H352.227L347.359 46.8794Z"
        fill="currentColor"
      />
      <defs>
        <radialGradient
          id={gid(0)}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.8134 82.5782) rotate(-37.4094) scale(43.6949 42.5459)"
        >
          <stop stopColor="#00C6CF" />
          <stop offset="1" stopColor="#17976A" />
        </radialGradient>
        <radialGradient
          id={gid(1)}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(68.1955 27.9534) rotate(142.75) scale(43.887 42.6676)"
        >
          <stop stopColor="#26FDB2" />
          <stop offset="1" stopColor="#17976A" />
        </radialGradient>
      </defs>
    </svg>
  )
}
